import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { useLang, localName } from './lang';

/**
 * Returns a lookup that localizes a status by id, using the shared ['statuses']
 * query cache. Falls back to the supplied English name until the list loads.
 * Used by screens that only carry a status id (calendar blocks, dashboard,
 * reports) — the booking dialog has the full Status objects and localizes them
 * directly via `localName`.
 */
export function useStatusName(): (id: number | null | undefined, fallback?: string | null) => string {
  const { lang } = useLang();
  const { data } = useQuery({ queryKey: ['statuses'], queryFn: api.statuses });
  return (id, fallback) => {
    const s = id != null ? data?.find((x) => x.id === id) : undefined;
    return s ? localName(lang, s.name, s.name_ar) : fallback ?? '';
  };
}
